/**
 * Fragment of a nationality name which qualifies it as Polish ("Polska", "polskie", "Polish"...).
 */
const POLISH_NATIONALITY_PHRASE = "pols";

/**
 * Checks if given nationality is Polish one. Nationality is treated as Polish when it contains
 * "pols" phrase (case insensitive). Only for Polish nationality PESEL is required and validated.
 *
 * @param {string} nationality Nationality name
 * @returns {Boolean} True when nationality is Polish one
 */
function isPolishNationality(nationality) {
    if (!nationality) {
        return true;
    }

    return nationality.toLowerCase().includes(POLISH_NATIONALITY_PHRASE);
}

export {isPolishNationality, POLISH_NATIONALITY_PHRASE};
